<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.MscBlAddress')"
    :close-on-click-modal="false"
    width="768px"
  >
    <el-form label-width="165px" inline label-position="left">
      <el-form-item :label="$t('SeaExport.CompanyName')" class="marginLeft">
        <el-input v-model="form.companyName" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.VipCode')" class="marginLeft">
        <el-input v-model="form.vipCode" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('SeaExport.GroupCode')" class="marginLeft">
        <el-input v-model="form.groupCode" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.MscCode')" class="marginLeft">
        <el-input v-model="form.mscCode" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('SeaExport.CompanyAddress')" class="marginLeft">
        <el-input v-model="form.companyAddress" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.InttraCode')" class="marginLeft">
        <el-input v-model="form.inttraCode" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('SeaExport.City')" class="marginLeft">
        <el-input ref="cityNameInput" v-model="form.cityName" @focus="cityClickHandler" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.OtherInformation')" class="marginLeft">
        <el-input v-model="form.otherInformation" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('SeaExport.ZipCode')" class="marginLeft">
        <el-input v-model="form.zipCode" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.BlTitle')" class="marginLeft">
        <el-input v-model="form.blTitle" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('SeaExport.Contact')" class="marginLeft">
        <el-input v-model="form.contact" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.BlAddress')" class="marginLeft">
        <el-input v-model="form.blAddress" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('SeaExport.Tel')" class="marginLeft">
        <el-input v-model="form.phone" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.BlContact')" class="marginLeft">
        <el-input v-model="form.blContact" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('SeaExport.Fax')" class="marginLeft">
        <el-input v-model="form.fax" />
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: center;">
      <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
      <el-button @click="closeHandler">{{ $t('common.btn.close') }}</el-button>
    </div>
    <location-search-dialog
      :visible.sync="cityDialogVisible"
      @addCallBack="selectLocalHandler"
      @close="cityDialogVisible=false"
    />
  </el-dialog>
</template>

<script>
import * as mscHistoryBillAddressApi from '@/api/basicData/mscHistoryBillAddress'
import LocationSearchDialog from '@/views/cargo/v0/Information/components/LocationSearchDialog'

export default {
  name: 'FormDialog',
  components: { LocationSearchDialog },
  props: {
    visible: { type: Boolean, required: true },
    isEdit: { type: Boolean, required: true },
    uuid: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      cityDialogVisible: false,
      form: {
        companyName: '',
        vipCode: '',
        groupCode: '',
        mscCode: '',
        companyAddress: '',
        inttraCode: '',
        city: '',
        cityName: '',
        otherInformation: '',
        zipCode: '',
        blTitle: '',
        contact: '',
        blAddress: '',
        phone: '',
        blContact: '',
        fax: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.loadForm()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    loadForm() {
      if (this.uuid) {
        mscHistoryBillAddressApi.queryByUuid({ uuid: this.uuid }).then(resp => {
          Object.assign(this.form, resp.data)
        })
      } else {
        this.form = this.getInitForm()
      }
    },
    saveHandler() {
      if (this.validate()) {
        this.fillModel()
        this.$emit('saveCallBack', this.form)
      }
    },
    validate() {
      if (!this.form.companyName || this.form.companyName.trim() === '') {
        this.$message.info(this.$t('SeaExport.CompanyName') + this.$t('SeaExport.IsEmptyPleaseEnter'))
        return false
      }
      return true
    },
    fillModel() {
      const form = this.form
      if (form) {
        const initForm = this.getInitForm()
        for (const key in initForm) {
          const val = form[key]
          if (val) {
            form[key] = val.trim()
          }
        }
      }
    },
    closeHandler() {
      this.$emit('close')
    },
    getInitForm() {
      return {
        companyName: '',
        vipCode: '',
        groupCode: '',
        mscCode: '',
        companyAddress: '',
        inttraCode: '',
        city: '',
        cityName: '',
        otherInformation: '',
        zipCode: '',
        blTitle: '',
        contact: '',
        blAddress: '',
        phone: '',
        blContact: '',
        fax: ''
      }
    },
    cityClickHandler() {
      this.$refs.cityNameInput.blur()
      this.cityDialogVisible = true
    },
    selectLocalHandler(location) {
      this.location = location
      this.form.cityName = location.englishName
    }
  }
}
</script>

<style scoped>
  .marginLeft {
    margin-left: 30px;
  }
</style>
